import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Skeleton as SkeletonComponent } from '@shared/components/Skeleton';

interface SkeletonProps
  extends Readonly<{
    featureCount?: number;
    enableHorizontalView?: boolean;
  }> {}

export const Skeleton: React.FC<SkeletonProps> = ({ featureCount = 3, enableHorizontalView = false }) => {
  return (
    <Box
      display="flex"
      flexDirection={enableHorizontalView ? 'row' : 'column'}
      backgroundColor="white"
      borderRadius={pxToRem(12)}
      boxShadow="0px 2px 8px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.04)"
      overflow="hidden"
      width="100%"
    >
      {/* Photo - 16:9 aspect ratio container */}
      <Box
        position="relative"
        width={enableHorizontalView ? '40%' : '100%'}
        paddingBottom={enableHorizontalView ? '22.5%' : '56.25%'}
        backgroundColor="mono3"
        flexShrink={0}
      >
        <SkeletonComponent
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          borderRadius={0}
        />
      </Box>

      {/* Header & Content */}
      <Flex
        flexDirection="column"
        paddingTop={5}
        paddingBottom={6}
        paddingX={4}
        width="100%"
      >
        {/* Title */}
        <SkeletonComponent
          width="60%"
          height={pxToRem(24)}
          borderRadius={pxToRem(4)}
        />
        {/* Distance */}
        <SkeletonComponent
          width="40%"
          height={pxToRem(16)}
          marginTop={3}
          borderRadius={pxToRem(4)}
        />
        {/* Description */}
        <SkeletonComponent
          width="90%"
          height={pxToRem(14)}
          marginTop={3}
          borderRadius={pxToRem(4)}
        />

        {/* Features */}
        <Flex
          flexDirection="column"
          paddingY={3}
          gap={3}
          marginTop={3}
        >
          {Array.from({ length: featureCount }).map((_, idx) => (
            <Flex
              key={idx}
              alignItems="center"
              gap={3}
            >
              <SkeletonComponent
                width={pxToRem(16)}
                height={pxToRem(16)}
                borderRadius={pxToRem(2)}
                flexShrink={0}
              />
              <SkeletonComponent
                width={`${70 - idx * 10}%`}
                height={pxToRem(16)}
                borderRadius={pxToRem(4)}
              />
            </Flex>
          ))}
        </Flex>

        {/* CTA Button placeholder */}
        <SkeletonComponent
          width="100%"
          height={pxToRem(44)}
          marginTop={4}
          borderRadius={pxToRem(8)}
        />
      </Flex>
    </Box>
  );
};
